module.exports = __webpack_public_path__ + "static/media/about.629e32e8.jpg";